import request from '@/util/request.js';

// 获取oic
function getcartList(){
    return request.get(`/api1.0/oic`).then(response => {
        return response
    })
}

// 获取图标fb 和 line等
function getwebsite(url){
    const baseApiUrl = url ? `${url}/api1.0/website_config` : '/api1.0/website_config';
    return request.get(baseApiUrl).then(response => {
        // console.log(response);
        return response
    });
}

//获取fb内容
function getfb(){
    return request.get('/api1.0/fb').then(response => {
        return response
    });

}

// 获取后台数据
function getnav(url){
    const baseApiUrl = url ? `${url}/api/v2/ft_theme/waca` : '/api/v2/ft_theme/waca';
    // const url = `/api/v2/ft_theme/waca`;
    return request.get(baseApiUrl).then(response => {
        return response.data?.data
    });
}


export default {
    getcartList,
    getwebsite,
    getnav,
    getfb
}